// extracted by mini-css-extract-plugin
export var banner = "_3l-0";
export var icon = "_3l-1";
export var message = "_3l-2";